@if ((isMasonry() || isMasonryWithLabel()) && items.length > 0) {
  <dg-record-masonry
    [items]="items"
    [viewMode]="viewMode"
  ></dg-record-masonry>
}

@if (isFancybox()) {
  <div class="p-2">
    <div class="grid gallery-grid-basic grid-cols-browser-gallery-mobile md:grid-cols-browser-gallery gap-1 p-2">
      @for (item of fancyboxImages; track item; let index = $index) {
        <a
          [attr.data-info]="item.caption"
          [attr.data-thumb]="item.thumb"
          [href]="item.original"
          data-fancybox="gallery"
          >
          <img [defaultImage]="defaultImage" [lazyLoad]="item.thumb" class="rounded h-64 md:h-128" />
        </a>
      }
    </div>
  </div>
}

@if (isOpenLayers()) {
  <dg-record-open-layers
    [activeRecordId]="activeRecordId"
    [pagination]="pagination"
    [items]="items"
    class="block h-full"
    >
  </dg-record-open-layers>
}
